// @ts-check

import {
  Mappedin,
  MapView,
  showVenue
} from "@mappedin/mappedin-js";
import { useEffect, useState } from "react";


/**
 * @typedef {import("@mappedin/mappedin-js").TShowVenueOptions} TShowVenueOptions
 * @typedef {import("@mappedin/mappedin-js").TGetVenueOptions} TGetVenueOptions
 * @typedef {import("@mappedin/mappedin-js").TMapViewOptions} TMapViewOptions
 * 
 */

//* @param {TShowVenueOptions} options

/**
 * @param {HTMLElement | null} el
 * @param {Mappedin | undefined} venue
 * @param {TMapViewOptions} options
 */
export default function useMapView(el, venue, options) {

  /** 
  * @type {[MapView | undefined, Function]}
  */
  const [mapView, setMapView] = useState();


  useEffect(() => {
    async function renderVenue() {
      if (el == null || venue == null) {
        return;
      }

      if (mapView != null && mapView.venue.venue.id === venue.venue.id) {
        return;
      }

      if (mapView != null) {
        mapView.destroy();
      }

      try {
        const _mapView = await showVenue(el, venue, options);
        setMapView(_mapView);
      } catch (e) {
        setMapView(undefined);
      }
    }

    renderVenue();
  }, [el, venue, options, mapView]);

  return mapView;
}
